module.exports = __webpack_public_path__ + "img/118.75d66427.png";